import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTemperatureLow,
  faRoad,
  faTruckMoving,
  faCubes,
  faHouseChimney,
  faLeaf,
} from '@fortawesome/free-solid-svg-icons';
import './styles/Header.css';
import TabletAndPhoneMenu from './TabletAndPhoneMenu';
import mascotLogo from '../images/jbc-mascot.png';

const services = [
  { title: 'Jordvarme', path: '/jordvarme', icon: faTemperatureLow },
  { title: 'Belægning', path: '/belægning', icon: faRoad },
  { title: 'Midlertidig Vej', path: '/midlertidig-vej', icon: faTruckMoving },
  { title: 'Fundamenter', path: '/fundamenter', icon: faCubes },
  { title: 'Tilbygning', path: '/tilbygning', icon: faHouseChimney },
  { title: 'LCA & Bæredygtighed', path: '/lca', icon: faLeaf },
];

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenDropdown(null);
  };

  const toggleDropdown = (index) => {
    setOpenDropdown((prevState) => (prevState === index ? null : index));
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : 'not-scrolled'}`}>
      <div className="header-content">
        <Link to="/" className="logo-container">
          <img src={mascotLogo} alt="JBC Entreprenøren" className="logo-mascot" />
          <span className="logo-wordmark">
            <span className="logo-wordmark-main">JBC Entreprenøren ApS</span>
            <span className="logo-wordmark-sub">Anlæg &amp; Byggeri</span>
          </span>
        </Link>
        <nav className="main-nav">
          <ul>
            <li><Link to="/">Hjem</Link></li>
            <li><Link to="/om-os">Om os</Link></li>
            <li className={`dropdown ${openDropdown === 0 ? 'open' : ''}`}>
              <span onClick={() => toggleDropdown(0)}>Tjenester</span>
              <ul className="dropdown-menu">
                {services.map((service) => (
                  <li key={service.path}>
                    <Link to={service.path}>
                      <span className="dropdown-icon">
                        <FontAwesomeIcon icon={service.icon} />
                      </span>
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li><Link to="/kontakt" className="nav-cta">Kontakt</Link></li>
          </ul>
        </nav>
        <div className={`menu-toggle ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <TabletAndPhoneMenu isOpen={isMenuOpen} toggleMenu={toggleMenu} />
      <div className={`menu-overlay ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}></div>
    </header>
  );
}

export default Header;
